import { gql } from "@apollo/client";
import { CurbArea } from "./GetCurbAreas";

/**
 * A payee's curb areas (e.g. SMF's terminals, AUT-5954), filtered explicitly to that payee's
 * jurisdiction rather than relying on app_user's permission scoping alone -- so the result stays
 * one jurisdiction's areas even if a role is later allowed to see curb areas across several.
 */
export const GET_PAYEE_CURB_AREAS = gql`
  query GetPayeeCurbAreas($payeeAccountId: uuid!) {
    curbAreas: curb_area(
      where: { payee_account: { id: { _eq: $payeeAccountId } } }
      order_by: [{ name: asc }, { id: asc }]
    ) {
      id
      name
      curbAreaZones: zones {
        zone {
          id
          name
        }
      }
    }
  }
`;

export interface PayeeCurbArea extends CurbArea {
  curbAreaZones: { zone: { id: string; name: string } }[];
}

export interface GetPayeeCurbAreasData {
  curbAreas: PayeeCurbArea[];
}

export interface GetPayeeCurbAreasVars {
  payeeAccountId: string;
}

export default GET_PAYEE_CURB_AREAS;
